import { shopAnalyticsViewItems, shopAnalyticsViewItem } from './analytics'

/**
 *
 * @param category_id
 * @param page
 * @param count
 * @param sort
 * @param types
 * @param makers
 * @param filters
 * @returns {Promise<any|{success: boolean}>}
 */
export const shopProducts = async ({
  category_id = null,
  page = null,
  page_limit = null,
  sort = null,
  types = [],
  makers = [],
  filters = {},
}) => {
  try {
    const urlData = []

    if (category_id) {
      urlData.push(`category_id=${category_id}`)
    }

    if (page) {
      urlData.push(`page=${page}`)
    }

    if (page_limit) {
      urlData.push(`page_limit=${page_limit}`)
    }

    if (sort) {
      urlData.push(`sort=${sort}`)
    }

    types.forEach((type) => {
      urlData.push(`types[]=${type}`)
    })

    makers.forEach((maker) => {
      urlData.push(`makers[]=${maker}`)
    })

    Object.entries(filters).forEach(([key, values]) => {
      values.forEach((value) => {
        urlData.push(`filer[${key}][]=${value}`)
      })
    })

    const response = await fetch(
      `get/api/shop/products${urlData.length ? `?${urlData.join('&')}` : ''}`,
      {
        method: 'get',
        credentials: 'include',
        headers: {
          Accept: 'application/json',
        },
      }
    )

    if (!response.ok) {
      throw new Error('Something went wrong')
    }

    const responseData = await response.json()

    if (responseData.success) {
      shopAnalyticsViewItems(responseData.products)
    }

    return responseData
  } catch (error) {
    console.error(error)
  }

  return {
    success: false,
  }
}

/**
 *
 * @param id_hash
 * @returns {Promise<any|{success: boolean}>}
 */
export const shopProduct = async ({ id_hash }) => {
  try {
    const response = await fetch(`get/api/shop/product?id_hash=${id_hash}`, {
      method: 'get',
      credentials: 'include',
      headers: {
        Accept: 'application/json',
      },
    })

    if (!response.ok) {
      throw new Error('Something went wrong')
    }

    const responseData = await response.json()

    if (responseData.success) {
      shopAnalyticsViewItem(responseData.product)
    }

    return responseData
  } catch (error) {
    console.error(error)
  }

  return {
    success: false,
  }
}
